import type {HTMLAttributes} from 'react'

import {cn} from '@/lib/utils'

export function CardContent({className, ...props}: HTMLAttributes<HTMLDivElement>) {
  return <div data-slot="card-content" className={cn('px-5 py-4', className)} {...props} />
}
